// TEK KAYNAK (G12): Hizmet kategorisi listesi. Kopya liste tutan tüm ekranlar
// (ServiceFormModal, PreInterviews, PreInterviewForm, Hizmetler) buradan import eder.
// G2/G3 (2026-08-29): 'Paketler' ve 'Göçük Düzeltme' yeni girişten emekli edildi,
// 'PPF Full Body' eklendi. Eski kayıtların GÖRÜNTÜLENMESİ değişmedi (çift-format).
export const hizmetTipleri = ['Cam Filmi', 'PPF Kaplama', 'PPF Full Body', 'Seramik Kaplama', 'Detay Temizlik', 'Yıkama', 'Diğer'];

// TEK KAYNAK (G12): Kategori renkleri. Liste değişse bile eski kategori adları
// (çift-format görüntüleme için) bu haritada TANINMAYA devam eder — silinmez.
export const kategoriRenkleri = {
    'Paketler': '#616161',
    'PPF Kaplama': '#e65100',
    'PPF Full Body': '#bf360c',
    'Cam Filmi': '#1565c0',
    'Seramik Kaplama': '#7b1fa2',
    'Detay Temizlik': '#2e7d32',
    'Yıkama': '#00838f',
    'Göçük Düzeltme': '#5d4037',
    'Diğer': '#616161'
};

export const getKategoriRengi = (kategori) => kategoriRenkleri[kategori] || '#616161';

export const aracTurleri = ['Hatchback', 'Sedan', 'SUV', 'Station Wagon', 'Cabrio', 'Coupe', 'Ticari', 'Diğer'];

export const durumlar = ["Yeni Görüşme", "Taslak", "Müşteriye Dönüştü", "İptal Oldu"];

// Arşiv sekmesine düşen durumlar (tek kaynak).
export const arsivDurumlari = ["Müşteriye Dönüştü", "İptal Oldu"];

// Durum artık formdan elle seçilmiyor; yalnızca sekme/arşiv/dönüşüm akışı yazar.
// Canlıda v1'den kalma tanınmayan değerler var ('Yeni' ×6, 'Aranacak' ×2) — bunlar
// hiçbir sekmenin filtresine girmediği için kayıtlar uygulamada görünmez oluyordu.
// Güvenlik ağı: tanınmayan her durum 'Yeni Görüşme' gibi ele alınır (veri DEĞİŞMEZ,
// yalnız okuma normalize edilir; kalıcı düzeltme Faz 9 onarımında yapılacak).
export const normalizePreInterviewDurum = (durum) => (
    durumlar.includes(durum) ? durum : 'Yeni Görüşme'
);

// `normalizePreInterviewDurum` ile 'Yeni Görüşme'ye düşen durumların AÇIK listesi.
// Normalizasyon "tanınmayan her değer" kuralıyla çalışır; Firestore `in` sorgusu
// ise açık bir liste ister. Canlıdaki tanınmayan değerler Faz 1 teşhisinde tek tek
// sayıldı ('Yeni' ×6, 'Aranacak' ×2) — liste onlardan türetildi. Faz 9 onarımından
// sonra sorgu pratikte yalnız 'Yeni Görüşme' ile çalışacak; liste zararsız kalır.
export const yeniGorusmeDurumlari = ['Yeni Görüşme', 'Yeni', 'Aranacak'];

// Not girişinde tek tıkla eklenen hazır etiketler.
export const hizliNotEtiketleri = ['Fiyat sordu', 'Müsait değildi', 'Tekrar aranacak', 'Parça bekleniyor'];

// Randevu durumları AppointmentConstants.js'e taşındı (tek kaynak) — burada tutulmuyor.

export const camParts = ["Ön Sürüş Camı", "Arka Cam", "Ön Yan Camlar", "Arka Yan Camlar", "Sunroof", "Cam Tavan"];

export const seramikParts = ["Kaput", "Ön Tampon", "Arka Tampon", "Farlar", "Ön İki Çamurluk", "Arka İki Çamurluk", "Ön İki Kapı", "Arka İki Kapı", "Bagaj", "Tavan", "B/C Sütunları", "Kapı Tutacakları"];

export const ppfParts = [...seramikParts];

export const getStatusChipColor = (status) => {
    const colors = {
        'Yeni Görüşme': 'info',
        'Taslak': 'warning',
        'Müşteriye Dönüştü': 'success',
        'İptal Oldu': 'error',
        'Bekleniyor': 'info',
        'Onaylandı': 'success',
        'İptal': 'error',
        'Tamamlandı': 'primary'
    };
    return colors[status] || 'default';
};
